"use client";

import { usePathname } from "next/navigation";
import { Suspense, useEffect } from "react";
import dynamic from "next/dynamic";
import { AnimatePresence, LazyMotion, domAnimation, m } from "framer-motion";
import type { SiteSettings } from "@/types/settings";
import { useAppContext } from "./appContext";
import FormCta from "./forms/formCta";
import FormContact from "./forms/formContact";

const Lightbox = dynamic(
  () => import("./lightbox").then((mod) => mod.default),
  {
    ssr: false,
  }
);

interface Props {
  settings?: SiteSettings;
  children: React.ReactNode;
}

export default function LayoutWrapper(data: Props) {
  const pathname = usePathname();

  const { menu, lightbox, toggleMenu, closeLightbox } = useAppContext();

  useEffect(() => {
    const body = document.querySelector("body");

    body?.classList.remove("page-transition");
  }, [pathname]);

  return (
    <LazyMotion features={domAnimation}>
      <AnimatePresence>
        {(menu || lightbox) && (
          <m.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
            className={`${menu ? "z-[1000000]" : "z-[1000003]"} fixed h-screen w-screen top-0 left-0 bg-black/20 backdrop-blur-lg`}
            onClick={() => {
              toggleMenu(null);
              closeLightbox();
            }}
          />
        )}
      </AnimatePresence>

      <div className="animation-layer fixed pointer-events-none bg-black fixed left-0 w-screen h-0 z-[999999999] shadow-lg flex items-center justify-center overflow-hidden">
        tmrw marketing
      </div>
      <div className="wrapper min-h-screen">{data.children}</div>

      <Suspense>
        <Lightbox id={`cta`} data={data.settings?.ctaSettings}>
          {" "}
          <FormCta />
        </Lightbox>
        <Lightbox id={`contact`} data={data.settings?.ctaSettings}>
          {" "}
          <FormContact />
        </Lightbox>
      </Suspense>
    </LazyMotion>
  );
}
